import React, { useState } from 'react'

export const ThemeContext = React.createContext({ Theme: false as any, setTheme: null as any })

interface ThemeProviderProps {
  children: JSX.Element
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  type ThemeProps = {
    isDark: boolean
  }

  const stored = localStorage.getItem('isDark')
  // Sober, professional default: light theme.
  const initialDark = stored !== null ? JSON.parse(stored) === true : false

  const [Theme, setTheme] = useState<ThemeProps>({ isDark: initialDark })

  return (
    <ThemeContext.Provider value={{ Theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}
